module.exports = __webpack_public_path__ + "img/dodatoc2.b1d3e412.png";